import React from 'react'
import Image from 'react'
import image from '../Myimages/pic.jpg'
import './hero.css'

export default function hero() {
   return (
      <div className=' heros text-white w-full flex justify-between text-start p-10   items-center h-[90dvh]'>
         <div className='hero w 2/4 pt-20 px-12'>
            <h1 className='focus-in-expand text-3xl md:text-6xl font-bold flex leading-normal tracking-tighter'>
              Hello' I am Fahad ali
            </h1>
            <p className='text-sm md:text-2xl  tracking-tight pt-2 flex flex-wrap  '>
               I am a creative and detail
               oriented Front-End
               Developer. 
               Skilled in  HTML, <br /> CSS,
               JavaScript, and React.js.

               I build responsive and
               user-friendly web
               interfaces
            </p>
            <div className=' flex gap-4 mt-10'>
               <button className='btn  text-white  hover:opacity-85
            duration-300 hover:scale-105 font-bold bg-slate-600  hover:bg-gray-900 rounded-3xl px-3 py-2  text-lg'>Contact me</button>

               <button
                  className="btn cursor-pointer flex justify-between bg-[var(--hero-bg)] px-3 py-2 rounded-full text-white tracking-wider shadow-xl hover:bg-gray-900 hover:scale-105 duration-500 hover:ring-1 text-xl font-mono w-[150px] "
               >
                  Resume
                  <svg
                     xmlns="http://www.w3.org/2000/svg"
                     fill="none"
                     viewBox="0 0 24 24"
                     stroke-width="2"
                     stroke="currentColor"
                     class="w-5 h-5 animate-bounce"
                  >
                     <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        d="M19.5 13.5 12 21m0 0-7.5-7.5M12 21V3"
                     ></path>
                  </svg>
               </button>
            </div>

            

         </div>
         <div className='hero-img slide-fwd-center'>
            <img className= ' w-96 h-96 mx-44 rounded-full shadow-xl shadow-slate-950' src={image} alt="" />
         </div>
      </div>
   )
}
